import { isParticipantUser } from './isParticipantUser';

export function isParticipantInvitable(participant) {
    return !isParticipantUser(participant) && !participant.status_flags?.cancelled && !participant.listing_only;
}
